import { Directive } from '@angular/core';
import { TemplateRefDirective } from 'src/app/utils/template-ref-directive';

@Directive({
    selector: '[appListingHeader]',
    standalone: false
})
export class ListingHeaderDirective extends TemplateRefDirective {
}
